import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { NouisliderModule } from 'ng2-nouislider';

import { ProductComponent } from './product.component';
import { ProductFiltersComponent } from './product-filters/product-filters.component';
import { RatingComponent } from '../shared/components/rating-generator.component';

import { RangeSliderComponent } from '../shared/components/range-slider.component';
import { FeaturedProductComponent } from './featured-product/featured-product.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { SearchComponent } from './search/search.component';
import { ProductFilterCrumbsComponent } from './product-filter-crumbs/product-filter-crumbs.component';
import { CompareOverlayComponent } from './compare/compare-overlay/compare-overlay.component';
import { ComparePageComponent } from './compare/compare-page/compare-page.component';
import { CssLoadingIndicator } from '../shared/css-loading';
import { DrLoadingIndicator } from '../shared/dr-loading';
import { LoadMoreComponent } from '../shared/components/load-more';
import { HatchOverlayComponent } from './hatch-overlay/hatch-overlay.component';
import { SuggestedProductComponent } from './suggested-product/suggested-product.component';
import { FooterComponent } from '../shared/layout/footer/footer.component';
import { ModalComponent } from '../shared/components/modal.component';
import { ModalService } from '../shared/service/modal.service';
import { SimpleDropdown } from '../shared/components/simple-dropdown';
import { PreviousRouteService } from '../shared/service/previous-route.service';
import { PopoverComponent } from '../shared/components/popover.component';
import { NgxSelectModule } from "ngx-select-ex";
import { ProductPdpComponent } from './product-pdp/product-pdp.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    NouisliderModule,
    ReactiveFormsModule,
    NgxSelectModule,
  ],
  exports: [],
  declarations: [
    ProductComponent,
    ProductFiltersComponent,
    RatingComponent,
    RangeSliderComponent,
    FeaturedProductComponent,
    ProductDetailsComponent,
    SearchComponent,
    ProductFilterCrumbsComponent,
    CompareOverlayComponent,
    ComparePageComponent,
    CssLoadingIndicator,
    DrLoadingIndicator,
    LoadMoreComponent,
    HatchOverlayComponent,
    SuggestedProductComponent,
    FooterComponent,
    ModalComponent,
    SimpleDropdown,
    PopoverComponent,
    ProductPdpComponent
  ],
  providers: [ModalService, PreviousRouteService],
  schemas: [NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductModule { }
